import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  CContainer,
  CCard,
  CCardBody,
  CRow,
  CCol,
  CImage,
  CForm,
  CFormInput,
  CFormFloating,
  CFormLabel,
} from "@coreui/react";
import axios from "../api/axios";
import LogoImg from "../assets/images/diamond-threading-salaon-logo.png";
import Datacontext from "../components/Datacontext";
import "./Service.css";
import Button from "../components/Globals/Button";

import { ERRORS, REQUIRED_FIELDS } from "../ERROR";
import useError from "../hooks/useError";

const ClientRegistration = () => {
  const [validated, setValidated] = useState(false);
  const { store_id, updateClientData, fwdcontact } = useContext(Datacontext);
  const [f_name, setFname] = useState("");
  const [l_name, setLname] = useState("");
  const [phone_no, setPhoneNo] = useState(fwdcontact || "");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const { showError } = useError();

  const handleClientData = (data) => {
    updateClientData(data);
  };

  const handleNumberChange = (event) => {
    setPhoneNo((prev) =>
      event.target.value.length <= 10
        ? event.target.value.replace(/\D/g, "")
        : prev
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (phone_no.length !== 10) {
      return;
    }

    // Handle form submission here, e.g., sending data to a server
    try {
      const response = await axios.post("/client/store", {
        f_name,
        l_name,
        phone_no,
        email,
        store_id,
      });
      // Assuming your API returns a token upon successful login
      const clientsdata = response.data.client;
      handleClientData(clientsdata);
      localStorage.setItem("clientsdata", JSON.stringify(clientsdata));
      navigate("/servicecard");
    } catch (error) {
      setValidated(true);
      showError(REQUIRED_FIELDS, ERRORS.ERROR);
    }
  };

  return (
    <>
      <CContainer className="d-flex justify-content-center vheight align-items-center">
        <CCard className="p-3 py-4  bg-light">
          <CCardBody className="text-center">
            <CImage src={LogoImg} width="70%" className="rounded mb-3" />
            <h3 className="mt-2">Sign Up</h3>
            <CForm
              className="g-3 needs-validation"
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
            >
              <CRow>
                <CCol md>
                  <CFormFloating className="mb-3">
                    <CFormInput
                      type="text"
                      id="firstname"
                      placeholder="First Name"
                      value={f_name}
                      onChange={(e) => setFname(e.target.value)}
                      feedbackInvalid="Please provide a first name."
                      required
                    />
                    <CFormLabel htmlFor="firstname">First name</CFormLabel>
                  </CFormFloating>
                </CCol>
                <CCol>
                  <CFormFloating className="mb-3">
                    <CFormInput
                      type="text"
                      id="lastname"
                      placeholder="Last Name"
                      value={l_name}
                      onChange={(e) => setLname(e.target.value)}
                      feedbackInvalid="Please provide a last name."
                      required
                    />
                    <CFormLabel htmlFor="lastname">Last name</CFormLabel>
                  </CFormFloating>
                </CCol>
              </CRow>

              <CRow>
                <CCol md="12">
                  <CFormFloating className="mb-3">
                    <CFormInput
                      type="tel"
                      id="mobile_number"
                      placeholder="Mobile Number"
                      value={phone_no}
                      onChange={handleNumberChange}
                      feedbackInvalid="Please provide valid phone"
                      invalid={phone_no.length !== 10}
                      required
                    />
                    <CFormLabel htmlFor="mobile_number">
                      Mobile Number
                    </CFormLabel>
                  </CFormFloating>
                </CCol>
                <CCol md="12">
                  <CFormFloating className="mb-3">
                    <CFormInput
                      type="email"
                      id="email"
                      placeholder="Email Address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      feedbackInvalid="Please provide youremail."
                      invalid={
                        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                          email
                        )
                      }
                      required
                    />
                    <CFormLabel htmlFor="email">Email Address</CFormLabel>
                  </CFormFloating>
                </CCol>
              </CRow>

              <CRow className="profile mt-2">
                <CCol>
                  <Button options={{ type: "submit", className: "w-100" }}>
                    Register
                  </Button>
                </CCol>
              </CRow>
              <p className="mt-3">
                Already Sign up? <Link to="/">Sign in here</Link>
              </p>
            </CForm>
          </CCardBody>
        </CCard>
      </CContainer>
    </>
  );
};

export default ClientRegistration;
